module.exports = __webpack_public_path__ + "img/ic_services_restaurant.433fdaca.svg";